import { useMutation } from '@tanstack/react-query';

import { updateUser } from '../api';
import { usersQueryKeys } from '../data';

export const useUpdateUser = () => {
  return useMutation({
    mutationKey: [...usersQueryKeys.updateUser],
    mutationFn: updateUser,
    onSuccess: (_data) => {},
    onError: (_error) => {},
  });
};
